import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ContentChild,
    EventEmitter,
    Input,
    Output,
    ViewEncapsulation,
} from '@angular/core';

import { CmpsCommitmentSummaryContext } from './commitment-summary';
import { CmpsCommitmentSummaryNoteDirective } from './commitment-summary-note.directive';

@Component({
    selector: 'cmps-coaching-commitment-summary-goal-row',
    template: ` <div class="cmps-coaching-commitment-summary-goal-row--record">
            <div class="cmps-coaching-commitment-summary-goal-row--left">
                <div>{{ modifiedElement }}</div>
                <div>{{ actionTaken }}</div>
                <div>{{ previousGoal }}</div>
                <div>{{ newGoal }}</div>
                <div>{{ user }}</div>
                <div>{{ sessionDate }}</div>
            </div>
            <div class="cmps-coaching-commitment-summary-goal-row--actions">
                <ng-container *ngIf="_context.showActionButtons">
                    <button
                        class="cmps-outline-button--sm cmps-outline-button--no-bg cmps-coaching-commitment-summary-row--action-button"
                        [class.cmps-coaching-commitment-summary--actions--accept]="
                            isSelectedAcceptedButton
                        "
                        cmpsOutlineButton
                        (click)="acceptAction.emit($event)"
                    >
                        <span cmpsOutlineButtonLabel>{{
                            acceptActionLabel
                        }}</span>
                    </button>
                    <button
                        class="cmps-outline-button--sm cmps-outline-button--no-bg cmps-coaching-commitment-summary-row--action-button"
                        [class.cmps-coaching-commitment-summary--actions--dispute]="
                            isSelectedDisputedButton
                        "
                        cmpsOutlineButton
                        (click)="disputeAction.emit($event)"
                    >
                        <span cmpsOutlineButtonLabel>{{
                            disputeActionLabel
                        }}</span>
                    </button>
                </ng-container>
                <div
                    [class.cmps-coaching-commitment-summary--actions-label--accept]="
                        isSelectedAcceptedButton
                    "
                    [class.cmps-coaching-commitment-summary--actions-label--dispute]="
                        isSelectedDisputedButton
                    "
                    *ngIf="_context.showActionLabel"
                >
                    <span>{{ actionResultLabel }}</span>
                </div>
            </div>
        </div>
        <div
            class="cmps-coaching-commitment-summary-goal-row--note"
            *ngIf="showNote"
        >
            <ng-container
                *ngTemplateOutlet="_noteTpl?.templateRef"
            ></ng-container>
        </div>`,
    host: {
        class: 'cmps-coaching-commitment-summary-goal-row',
        '[class.cmps-coaching-commitment-summary-goal-row--with-actions]':
            '_context.showActionButtons || _context.showActionLabel',
    },
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class CmpsCommitmentSummaryGoalRowComponent {
    /** @private */
    @ContentChild(CmpsCommitmentSummaryNoteDirective)
    readonly _noteTpl: CmpsCommitmentSummaryNoteDirective;

    @Input() modifiedElement: string;
    @Input() actionTaken: string;
    @Input() previousGoal: string;
    @Input() newGoal: string;
    @Input() user: string;
    @Input() sessionDate: string;

    @Input() acceptActionLabel: string;
    @Input() isSelectedAcceptedButton: boolean;
    @Output() acceptAction: EventEmitter<MouseEvent | KeyboardEvent>;
    @Input() disputeActionLabel: string;
    @Input() isSelectedDisputedButton: boolean;
    @Output() disputeAction: EventEmitter<MouseEvent | KeyboardEvent>;
    @Input() actionResultLabel: string;
    @Input() showNote: boolean;

    constructor(
        private readonly _changeDetectorRef: ChangeDetectorRef,
        /** @private */ readonly _context: CmpsCommitmentSummaryContext,
    ) {
        this.acceptAction = new EventEmitter();
        this.disputeAction = new EventEmitter();
    }

    ngOnDestroy(): void {
        this.acceptAction.complete();
        this.disputeAction.complete();
    }

    /** @internal */
    _check(): void {
        this._changeDetectorRef.markForCheck();
    }
}
